module.exports = __webpack_public_path__ + "img/wrench.a62d1c7e.svg";